import { useEffect, useState } from 'react';
import { Zap, Eye, Heart } from 'lucide-react';

const values = [
  {
    title: 'Simplicity First',
    description: 'Easy enough for volunteers, powerful enough for professionals',
    icon: Zap,
  },
  {
    title: 'Transparency Always',
    description: 'Real-time visibility into food costs and inventory',
    icon: Eye,
  },
  {
    title: 'Built for Camps',
    description: 'Every feature designed around the unique needs of youth and retreat kitchens',
    icon: Heart,
  },
];

export const MissionValues = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    const element = document.getElementById('mission-values');
    if (element) observer.observe(element);

    return () => observer.disconnect();
  }, []);

  return (
    <section id="mission-values" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Mission Statement */}
        <div className="text-center mb-16">
          <h2 className="font-playfair text-4xl md:text-5xl font-bold text-slate mb-6">
            Our Mission
          </h2>
          <p className="font-inter text-xl text-slate/80 max-w-3xl mx-auto leading-relaxed">
            To give every camp, big or small, access to professional-grade kitchen management tools. 
            We believe better food planning means happier campers, less waste, and more time for what 
            matters — building community.
          </p>
        </div>

        {/* Value Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {values.map((value, index) => {
            const Icon = value.icon;
            return (
              <div
                key={value.title}
                className={`group relative overflow-hidden rounded-xl p-8 bg-gradient-to-br from-deep-teal to-copper text-ivory shadow-lg transition-all duration-500 hover:shadow-2xl hover:scale-105 ${
                  isVisible
                    ? 'opacity-100 translate-y-0'
                    : 'opacity-0 translate-y-8'
                }`}
                style={{ transitionDelay: `${index * 150}ms` }}
              >
                <div className="relative z-10">
                  <div className="flex items-center justify-center w-16 h-16 mb-6 rounded-full bg-ivory/20 backdrop-blur-sm">
                    <Icon className="w-8 h-8 text-ivory" />
                  </div>
                  <h3 className="font-playfair text-2xl font-semibold mb-4">
                    {value.title}
                  </h3>
                  <p className="font-inter text-ivory/90 text-lg leading-relaxed">
                    {value.description}
                  </p>
                </div>
                
                {/* Hover Glow Effect */}
                <div className="absolute inset-0 bg-gradient-to-br from-copper/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
